import React, { useState, useEffect, useCallback } from "react";
import KanbanView from "./KanbanView";
import TableView from "./TableView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTh,
  faTable,
  faSync,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import { FaEnvelope, FaRegAddressCard } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import debounce from "lodash.debounce";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import ClipLoader from "react-spinners/ClipLoader";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "tailwindcss/tailwind.css";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import api from "../../utils/api"; // Import the API utility
import log from "../../utils/logger"; // Import the logger
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "tailwindcss/tailwind.css";
import {
  FaDownload,
  FaTimes,
  FaImage,
  // faSync
} from "react-icons/fa";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { PDFDocument } from "pdf-lib";
import { Dropdown, Modal, Space, Spin, Button, Select } from "antd";
import axios from "axios";
import { DeleteOutlined, DownOutlined, UserOutlined } from "@ant-design/icons";
const { Option } = Select;
GlobalWorkerOptions.workerSrc = pdfWorker;

const PrintQueue = () => {
  const [cards, setCards] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("table");
  const [selectedCards, setSelectedCards] = useState([]);
  const [selectCustomers, setSelectedCustomers] = useState([]);
  const [filter, setFilter] = useState("awaiting-action");
  const [searchQuery, setSearchQuery] = useState("");
  const [stateMap, setStateMap] = useState({});
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showSingleCardModal, setShowSingleCardModal] = useState(false);
  const [batchPreviewUrls, setBatchPreviewUrls] = useState([]);
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [thumbnailUrls, setThumbnailUrls] = useState({});
  const [modalType, setModalType] = useState("");
  const [filterEventDate, setFilterEventDate] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [allCustomer, setAllCustomer] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [limit, setLimit] = useState(10);
  const [totalData, setTotalData] = useState(0);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [pendingChange, setPendingChange] = useState(null);
  const [sortByTable, setSortByTable] = useState([]);

  const fetchCustomers = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/customer/get-all-customers`,
        {
          headers: { "x-sh-auth": localStorage.getItem("token") },
        }
      );
      if (response.data.code === 200) {
        setAllCustomer(response.data.data);
      }
    } catch (error) {
      console.error(`Error fetching data from :`, error);
    }
  }, []);

  const handleDownloadCompleteCards = useCallback(async () => {
    const zip = new JSZip();
    try {
      for (const url of batchPreviewUrls) {
        const pdfBytes = await fetch(url).then((res) => res.arrayBuffer());
        zip.file(`card_${batchPreviewUrls.indexOf(url) + 1}.pdf`, pdfBytes);
      }
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "cards.zip");
    } catch (error) {
      log.error("Failed to download complete cards:", error.message);
    }
  }, [batchPreviewUrls]);
  const generateFacePdf = useCallback(
    async (pageIndex) => {
      setLoading(true);
      const mergedPdf = await PDFDocument.create();
      try {
        for (const url of batchPreviewUrls) {
          const pdfBytes = await fetch(url).then((res) => res.arrayBuffer());
          const pdf = await PDFDocument.load(pdfBytes);
          if (pdf.getPageCount() > pageIndex) {
            const copiedPages = await mergedPdf.copyPages(pdf, [pageIndex]);
            copiedPages.forEach((page) => mergedPdf.addPage(page));
          }
        }
        const mergedPdfBytes = await mergedPdf.save();
        const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(blob);
        setPreviewUrl(pdfUrl);
      } catch (error) {
        log.error("Failed to generate face PDF:", error.message);
      } finally {
        setLoading(false);
      }
    },
    [batchPreviewUrls]
  );
  const handleRemoveBatchPreview = useCallback(
    (index) => {
      const newBatchPreviewUrls = [...batchPreviewUrls];
      newBatchPreviewUrls.splice(index, 1);
      setBatchPreviewUrls(newBatchPreviewUrls);
      const cardId = selectedCards[index];
      const customerId = selectCustomers[index];
      setSelectedCards(selectedCards.filter((id) => id !== cardId));
      setSelectedCustomers(selectCustomers.filter((id) => id !== customerId));

      if (newBatchPreviewUrls.length > 0) {
        setPreviewUrl(newBatchPreviewUrls[0]);
      } else {
        setPreviewUrl(null);
      }
    },
    [batchPreviewUrls, selectedCards, setSelectedCards, setSelectedCustomers]
  );
  const resetStates = useCallback(() => {
    setPreviewUrl(null);
    setBatchPreviewUrls([]);
    setShowBatchModal(false);
    setShowSingleCardModal(false);
    setThumbnailUrls({});
    setModalType("");
  }, []);
  const fetchStates = useCallback(async () => {
    try {
      const response = await api.get("/state/active_state_listing");
      if (response.data.code === 200) {
        const map = {};
        response.data.data.forEach((state) => {
          map[state._id] = state.state;
        });
        setStateMap(map);
      } else {
        toast.error("Failed to fetch states");
        log.error(`Failed to fetch states: ${response.data.message}`);
      }
    } catch (error) {
      log.error("Failed to fetch states:", error);
      toast.error("Failed to fetch states");
    }
  }, []);

  const fetchCards = useCallback(
    async (status = "", page = 1, limit = 10, searchQuery = "") => {
      let url = `/eventOfRecipient/get-all-customer-cards?page=${page}&limit=${limit}&searchQuery=${searchQuery}&filterEventDate=${filterEventDate}`;
      if (status === "awaiting-action") {
        url += `&status=completed`;
      } else if (status === "printed") {
        url += `&status=printed`;
      } else if (status) {
        url += `&status=${status}`;
      }

      setLoading(true);

      try {
        const response = await api.get(url);
        console.log("response cards@@@@", response.data);
        if (response.data.code === 200) {
          if (!response.data.data || !Array.isArray(response.data.data)) {
            throw new Error("Invalid data format");
          }
          setCards(
            response.data.data.map((card) => {
              const eventDate = new Date(card.finaleventdate);
              const printByDate = new Date(eventDate);
              printByDate.setDate(printByDate.getDate() - 5);
              const lockedDate = new Date(eventDate);
              lockedDate.setDate(lockedDate.getDate() - 7);
              const isLocked = new Date() >= lockedDate;
              return {
                ...card,
                status:
                  card.status === "completed" ? "awaiting action" : card.status,
                printByDate,
                isLocked,
              };
            })
          );
          setTotalPages(response?.data?.totalPages);
          // setPage(response?.data?.page);
          setTotalData(response?.data?.totalCount || 0);
          setSelectedCards([]);
          setSelectedCustomers([]);
        } else {
          toast.error("Failed to fetch cards");
          log.error(`Failed to fetch cards: ${response.data.message}`);
        }
      } catch (error) {
        log.error("Failed to fetch cards:", error);
        toast.error("Failed to fetch cards");
      } finally {
        setLoading(false);
      }
    },
    []
  );

  useEffect(() => {
    if (allCustomer.length === 0) fetchCustomers();
  }, []);

  useEffect(() => {
    fetchStates();
    if (view === "kanban") {
      fetchCards(filter, 1, 1000); // Fetch all records for Kanban view
    } else {
      fetchCards(filter, page, limit, searchQuery.trim());
    }
  }, [fetchCards, fetchStates, filter, page, limit, view, searchQuery]);

  const handleSelectCard = useCallback((cardId) => {
    setSelectedCards((prev) =>
      prev.includes(cardId)
        ? prev.filter((id) => id !== cardId)
        : [...prev, cardId]
    );
  }, []);

  const handleFilterChange = (value) => {
    // const selectedFilter = e.target.value;
    // setFilter(selectedFilter);
    console.log("Selected Value:", value);
    setFilter(value);
    setPage(1);
  };

  const debouncedSearchChange = useCallback(
    debounce((value) => {
      setSearchQuery(value);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (e) => {
    debouncedSearchChange(e.target.value);
  };

  const filterCards = (cards) => {
    let filteredCards = cards;

    switch (filter) {
      case "awaiting-action":
        filteredCards = cards.filter(
          (card) => card.status === "awaiting action"
        );
        break;
      case "printed":
        filteredCards = cards.filter((card) => card.status === "printed");
        break;
      case "mailed":
        filteredCards = cards.filter((card) => card.status === "mailed");
        break;
      default:
        filteredCards = cards;
        break;
    }

    return filteredCards;
  };

  const filteredCards = filterCards(cards);

  const allSelectedStatus = selectedCards.map(
    (id) => cards.find((card) => card._id === id)?.status
  );
  const allAwaitingAction = allSelectedStatus.every(
    (status) => status === "awaiting action"
  );
  const allPrinted = allSelectedStatus.every((status) => status === "printed");
  const canMarkAsPrinted = allAwaitingAction && allSelectedStatus.length > 0;
  const canMarkAsDelivered = allPrinted && allSelectedStatus.length > 0;

  const handleRefresh = () => {
    if (view === "kanban") {
      fetchCards(filter, 1, 1000); // Fetch all records for Kanban view
    } else {
      fetchCards(filter, page, limit);
    }
  };

  const handleCardClick = async (card) => {
    if (card.cardurl) {
      setPreviewUrl(card.cardurl);
      setShowSingleCardModal(true);
      return;
    }

    const requestBody = {
      greeting: card.textTo,
      body: card.textCard,
      signoff: card.textFrom,
      thumbnail: card.cardId.thumbnail,
    };

    setLoading(true);

    try {
      const response = await api.post("/admin/generate-card", requestBody);

      if (response.data.code === 200) {
        setPreviewUrl(response.data.data.url);
        setShowSingleCardModal(true);
      } else {
        log.error("Failed to generate card preview:", response.data.message);
        toast.error("Failed to generate card preview");
      }
    } catch (error) {
      log.error("Failed to generate card preview:", error.message);
      toast.error("Failed to generate card preview");
    } finally {
      setLoading(false);
    }
  };

  const handleEnvelopeClick = async (card) => {
    const { streetAddress, city, stateId, zipCode, fullName } = card.receiptsId;

    if (!streetAddress || !city || !stateId || !zipCode) {
      toast.error("Incomplete address information.");
      return;
    }

    const requestBody = {
      return_address: {
        name: "The Johnsons",
        address: ["123 NORTH MAIN STREET", "SMALLTOWN, MAINE 12345"],
      },
      addresses: [
        {
          Name: fullName,
          Street: streetAddress,
          City: city,
          State: stateMap[stateId] || stateId,
          ZIP: zipCode,
        },
      ],
    };

    setLoading(true);

    try {
      const response = await api.post("/admin/generate-envelope", requestBody);

      if (response.data.code === 200) {
        setPreviewUrl(response.data.data.s3_links[0]);
        setShowSingleCardModal(true);
      } else {
        log.error(
          "Failed to generate envelope preview:",
          response.data.message
        );
        toast.error("Failed to generate envelope preview");
      }
    } catch (error) {
      log.error("Failed to generate envelope preview:", error.message);
      toast.error("Failed to generate envelope preview");
    } finally {
      setLoading(false);
    }
  };
  const handleBatchCardsClick = useCallback(async () => {
    setModalType("cards");
    setBatchPreviewUrls([]);
    setLoading(true);
    try {
      for (const cardId of selectedCards) {
        const card = cards.find((c) => c._id === cardId);
        const requestBody = {
          greeting: card.textTo,
          body: card.textCard,
          signoff: card.textFrom,
          thumbnail: card.cardId.thumbnail,
        };

        const response = await api.post("/admin/generate-card", requestBody);
        log.info("API response:", response.data);

        if (response.data.code === 200) {
          const generatedUrl = response.data.data.url;
          log.info("Generated card URL:", generatedUrl);
          setBatchPreviewUrls((prev) => [...prev, generatedUrl]);
        }
      }
      setShowBatchModal(true);
    } catch (error) {
      log.error("Failed to generate batch card previews:", error.message);
    } finally {
      setLoading(false);
    }
  }, [selectedCards, cards]);

  const handleBatchEnvelopeClick = useCallback(async () => {
    setModalType("envelopes");
    setBatchPreviewUrls([]);
    setLoading(true);
    try {
      const addresses = selectedCards
        .map((cardId) => {
          const card = cards.find((c) => c._id === cardId);

          if (
            !card ||
            !card.receiptsId ||
            !card.receiptsId.streetAddress ||
            !card.receiptsId.city ||
            !card.receiptsId.stateId ||
            !card.receiptsId.zipCode
          ) {
            log.error(
              `Missing address information for card ID: ${cardId}`,
              card
            );
            return null;
          }

          return {
            Name: card.receiptsId.fullName,
            Street: card.receiptsId.streetAddress,
            City: card.receiptsId.city,
            State: stateMap[card.receiptsId.stateId] || card.receiptsId.stateId,
            ZIP: card.receiptsId.zipCode,
          };
        })
        .filter((address) => address !== null);

      if (addresses.length === 0) {
        throw new Error("No valid addresses found for the selected cards.");
      }

      const requestBody = {
        return_address: {
          name: "The Johnsons",
          address: ["123 NORTH MAIN STREET", "SMALLTOWN, MAINE 12345"],
        },
        addresses,
      };

      const response = await api.post("/admin/generate-envelope", requestBody);
      log.info("API response:", response.data);

      if (response.data.code === 200) {
        const flattenedUrls = response.data.data.s3_links.flat();
        log.info("Generated envelope URLs:", flattenedUrls);
        setBatchPreviewUrls(flattenedUrls);
        setShowBatchModal(true);
      }
    } catch (error) {
      log.error("Failed to generate batch envelope previews:", error.message);
    } finally {
      setLoading(false);
    }
  }, [selectedCards, cards, stateMap]);
  const generateThumbnail = useCallback(async (url, index) => {
    try {
      const loadingTask = getDocument(url);
      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1 });

      const canvas = document.createElement("canvas");
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      const context = canvas.getContext("2d");
      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      await page.render(renderContext).promise;

      const thumbnailUrl = canvas.toDataURL();
      setThumbnailUrls((prev) => ({ ...prev, [index]: thumbnailUrl }));
    } catch (error) {
      log.error("Failed to generate thumbnail:", error.message);
    }
  }, []);
  useEffect(() => {
    batchPreviewUrls.forEach((url, index) => {
      if (!thumbnailUrls[index]) {
        generateThumbnail(url, index);
      }
    });
  }, [batchPreviewUrls, thumbnailUrls, generateThumbnail]);

  const showConfirmationModal = (changeData) => {
    setPendingChange(changeData);
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    if (pendingChange) {
      const { newStatus, selectedCards, uniqueCustomers } = pendingChange;
      proceedWithChangeStatus(newStatus, selectedCards, uniqueCustomers);
    }
    setIsModalVisible(false);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setPendingChange(null);
  };
  const handleChangeStatus = useCallback(
    async (newStatus) => {
      setLoading(true);

      const uniqueCustomers = Array.from(new Set(selectCustomers));

      // Check if any customer in uniqueCustomers has subscription: true
      const hasSubscription = uniqueCustomers.some((customerId) => {
        const customer = allCustomer.find((c) => c._id === customerId); // Adjust 'id' based on your data
        return customer?.isSubscribed === true;
      });

      if (!hasSubscription) {
        // Show the Ant Design Modal
        showConfirmationModal({ newStatus, selectedCards, uniqueCustomers });
        setLoading(false);
        return;
      }

      // Proceed if subscriptions are valid
      await proceedWithChangeStatus(newStatus, selectedCards, uniqueCustomers);
    },
    [selectedCards, allCustomer, selectCustomers]
  );

  const proceedWithChangeStatus = async (
    newStatus,
    selectedCards,
    uniqueCustomers
  ) => {
    try {
      const response = await api.put(`/admin/change-status-admin/batch`, {
        cardIds: selectedCards,
        customerId: uniqueCustomers,
        newStatus,
      });

      if (response.data.code === 200) {
        setCards((prevCards) =>
          prevCards.map((card) =>
            selectedCards.includes(card._id)
              ? {
                  ...card,
                  status: newStatus === "printed" ? "printed" : "mailed",
                }
              : card
          )
        );
        setSelectedCards([]);
        setSelectedCustomers([]);
        fetchCards(filter, page, limit, searchQuery.trim());
        toast.success(`Selected cards marked as ${newStatus} successfully!`);
      } else {
        toast.error(`Failed to mark selected cards as ${newStatus}`);
      }
    } catch (error) {
      toast.error(`Failed to mark selected cards as ${newStatus}`);
    } finally {
      setLoading(false);
    }
  };

  // orders delete

  const handleDeleteCards = () => {
    setIsDeleteModalVisible(true);
  };

  const [deleteLoading, setDeleteLaoding] = useState(false);
  const handleDeleteModalOk = async () => {
    try {
      setDeleteLaoding(true);
      const response = await api.delete(
        `/eventOfRecipient/delete-customer-orders-admin`,
        {
          data: {
            ids: selectedCards,
          },
        }
      );
      if (response.data.code === 200) {
        handleRefresh();
        toast.success(`Selected cards deleted successfully!`);
        setIsDeleteModalVisible(false);
      }
    } catch (e) {
      toast.error("Failed to delete:", e.message);
    } finally {
      setDeleteLaoding(false);
    }
  };

  return (
    <div className="p-4 max-w-6xl mx-auto bg-white squared-lg shadow-lg relative z-0">
      {isModalVisible && (
        <Modal
          title={
            <div className="text-lg font-medium text-gray-800">
              Subscription Missing
            </div>
          }
          visible={isModalVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          okText="Proceed"
          cancelText="Cancel"
          footer={[
            <button
              key="cancel"
              onClick={handleModalCancel}
              className="py-2 px-4 text-sm mr-2 font-medium text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 focus:ring-2 focus:ring-gray-400"
            >
              Cancel
            </button>,
            <button
              key="proceed"
              onClick={handleModalOk}
              className="py-2 px-4 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 focus:ring-2 focus:ring-green-400"
            >
              Proceed
            </button>,
          ]}
          bodyStyle={{
            padding: "16px",
          }}
          wrapClassName="custom-modal"
          centered
        >
          <p className="text-gray-600">
            Some customers do not have an active subscription. Do you still want
            to change the status of their cards?
          </p>
        </Modal>
      )}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="flex justify-between items-center mb-2">
        <div className="flex space-x-1">
          <button
            onClick={() => setView("table")}
            className={`p-1 squared ${
              view === "table"
                ? "bg-primary text-white"
                : "bg-gray-100 hover:bg-primary-dark hover:text-white"
            }`}
          >
            <FontAwesomeIcon icon={faTable} />
          </button>
          <button
            onClick={() => setView("kanban")}
            className={`p-1 squared ${
              view === "kanban"
                ? "bg-primary text-white"
                : "bg-gray-100 hover:bg-primary-dark hover:text-white"
            }`}
          >
            <FontAwesomeIcon icon={faTh} />
          </button>
        </div>
        <div className="flex space-x-2">
          {canMarkAsPrinted && (
            <button
              onClick={() => handleChangeStatus("printed")}
              className="px-2 !py-1 bg-primary hover:bg-primary-dark text-white squared"
            >
              Mark as Printed
            </button>
          )}
          {canMarkAsDelivered && (
            <button
              onClick={() => handleChangeStatus("mailed")}
              className="px-2 py-1 bg-primary hover:bg-primary-dark text-white squared"
            >
              Mark as Mailed
            </button>
          )}
          {/* {view === "kanban" && ( */}
          <div className=" flex justify-end space-x-2">
            <button
              onClick={handleRefresh}
              className="px-2 py-1 bg-primary hover:bg-primary-dark text-white squared"
            >
              <FontAwesomeIcon icon={faSync} /> Refresh
            </button>

            <button
              onClick={selectedCards.length > 0 ? handleBatchCardsClick : null}
              className={`bg-primary text-white px-4 py-2 squared flex items-center ${
                selectedCards.length > 0
                  ? "hover:bg-primary-dark"
                  : "cursor-not-allowed opacity-50"
              }`}
            >
              <FaRegAddressCard className="mr-2" /> Print Cards
            </button>
            <button
              onClick={
                selectedCards.length > 0 ? handleBatchEnvelopeClick : null
              }
              className={`bg-blue-600 text-white px-4 py-2 squared flex items-center ${
                selectedCards.length > 0
                  ? "hover:bg-blue-800"
                  : "cursor-not-allowed opacity-50"
              }`}
            >
              <FaEnvelope className="mr-2" /> Print Envelopes
            </button>
            <button
              onClick={selectedCards.length > 0 ? handleDeleteCards : null}
              className={`bg-primary text-white px-4 py-2 squared flex items-center ${
                selectedCards.length > 0
                  ? "hover:bg-primary-dark"
                  : "cursor-not-allowed opacity-50"
              }`}
            >
              <DeleteOutlined className="mr-2" /> Delete Cards
            </button>
          </div>
          {/* )} */}
        </div>
      </div>
      <div className="mb-4 flex flex-wrap gap-2 justify-between items-center">
        {view !== "kanban" && (
          <div className="flex justify-between items-center mt-3 border-b-2 border-gray-200 pb-2">
            <span className="text-sm font-medium text-gray-700">
              Selected: {selectedCards.length}
            </span>
          </div>
        )}

        <Select
          onChange={handleFilterChange}
          value={filter}
          variant={"borderless"}
          className="w-full py-2.5 mt-2 sm:w-auto flex-grow border-b-2 border-gray-200 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 rounded-none"
          dropdownStyle={{ borderRadius: "0px" }} // Optional: Remove border radius for dropdown
          style={{ minWidth: "150px" }} // Ensure consistent width on all screen sizes
          showArrow={true} // Optional: To show the dropdown arrow explicitly
        >
          <Option value="awaiting-action">Awaiting Action</Option>
          <Option value="printed">Printed but Not Mailed</Option>
          <Option value="mailed">Mailed</Option>
          <Option value="all">All Orders</Option>
        </Select>

        <div className="w-4"></div>

        <input
          type="text"
          placeholder="Search..."
          onChange={handleSearchChange}
          className="block py-2.5 px-0 w-full sm:w-auto text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer flex-grow"
        />
      </div>

      {view === "kanban" && (
        <>
          {loading ? (
            <div className="text-center min-h-[500px] flex justify-center items-center">
              <Spin size="large" />
            </div>
          ) : (
            <KanbanView
              cards={filteredCards}
              stateMap={stateMap}
              handleCardClick={handleCardClick}
              handleEnvelopeClick={handleEnvelopeClick}
              selectedCards={selectedCards}
              setSelectedCards={setSelectedCards}
              setSelectedCustomers={setSelectedCustomers}
              onChangeStatus={handleChangeStatus}
              loading={loading}
              setLoading={setLoading}
            />
          )}
        </>
      )}
      {view === "table" && (
        <>
          {loading ? (
            <div className="text-center min-h-[500px] flex justify-center items-center">
              <Spin size="large" />
            </div>
          ) : (
            <>
              {filteredCards && filteredCards.length > 0 ? (
                <TableView
                  handleRefresh={handleRefresh}
                  cards={filteredCards}
                  selectedCards={selectedCards}
                  setSelectedCards={setSelectedCards}
                  setSelectedCustomers={setSelectedCustomers}
                  onChangeStatus={handleChangeStatus}
                  stateMap={stateMap}
                  totalDataCount={totalData}
                  setLoading={setLoading}
                  setFilterEventDate={setFilterEventDate}
                  pageData={page}
                  totalPagesData={totalPages}
                  onPageChange={setPage}
                  // pageSize={limit} // optional
                  // onPageSizeChange={setLimit}
                />
              ) : (
                <div className="text-center min-h-[500px] flex flex-col justify-center items-center text-gray-500">
                  <svg
                    className="w-16 h-16 mb-4 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 14l2-2m0 0l2-2m-2 2v6m0-6l-2-2m2 2l2-2m-2 2l2-2M4 4l16 16"
                    />
                  </svg>
                  <p className="text-lg font-semibold">No results found</p>
                  <p className="text-sm mt-2">
                    Try adjusting your search or filters to find what you’re
                    looking for.
                  </p>
                </div>
              )}
            </>
          )}
        </>
      )}
      {showSingleCardModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white p-4 squared-lg w-full max-w-4xl h-full flex flex-col relative z-60">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-semibold">Card Preview</h2>
              <button
                onClick={() => setShowSingleCardModal(false)}
                className="bg-primary text-white squared-full p-2"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="flex-grow h-full overflow-y-auto">
              {previewUrl && (
                <Worker workerUrl={pdfWorker}>
                  <Viewer
                    fileUrl={previewUrl}
                    plugins={[defaultLayoutPluginInstance]}
                    renderError={() => <div>Error loading PDF</div>}
                  />
                </Worker>
              )}
            </div>
          </div>
        </div>
      )}
      {showBatchModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white p-4 squared-lg w-full max-w-5xl h-full flex flex-col relative z-60">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-semibold">
                {modalType === "cards"
                  ? "Print Cards Preview"
                  : "Print Envelopes Preview"}
              </h2>
              <button
                onClick={resetStates}
                className="bg-primary text-white squared-full p-2"
              >
                <FaTimes />
              </button>
            </div>
            {loading ? (
              <div className="flex justify-center items-center h-full">
                <ClipLoader size={64} color={"#000"} />
              </div>
            ) : (
              <>
                {modalType === "cards" ? (
                  <div className="flex justify-center mb-4">
                    <button
                      onClick={() => generateFacePdf(0)}
                      className="bg-primary hover:bg-primary-dark text-white px-4 py-2 squared-l flex items-center"
                    >
                      <FaImage className="mr-2" /> All Outside Faces
                    </button>
                    <button
                      onClick={() => generateFacePdf(1)}
                      className="bg-primary hover:bg-primary-dark text-white px-4 py-2 squared-r flex items-center"
                    >
                      <FaImage className="mr-2" /> All Inside Faces
                    </button>
                  </div>
                ) : (
                  <div className="flex justify-center mb-4">
                    <button
                      onClick={() => generateFacePdf(0)}
                      className="bg-primary hover:bg-primary-dark text-white px-4 py-2 squared flex items-center"
                    >
                      <FaImage className="mr-2" /> All Envelopes
                    </button>
                  </div>
                )}
                <div className="flex h-full overflow-hidden">
                  <div className="w-1/4 overflow-y-auto pr-2 h-full">
                    {batchPreviewUrls.map((url, index) => (
                      <div key={index} className="relative mb-4">
                        <button
                          onClick={() => handleRemoveBatchPreview(index)}
                          className="absolute top-0 left-0 bg-primary text-white squared-full p-1"
                        >
                          <FaTimes />
                        </button>
                        <div
                          className="w-full h-32 border overflow-hidden cursor-pointer"
                          onClick={() => setPreviewUrl(url)}
                        >
                          {thumbnailUrls[index] ? (
                            <img
                              src={thumbnailUrls[index]}
                              alt={`Preview ${index}`}
                              className="w-full h-full object-fill"
                            />
                          ) : (
                            <div>Loading...</div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="flex-grow h-full overflow-y-auto pl-2">
                    {previewUrl && (
                      <Worker workerUrl={pdfWorker}>
                        <Viewer
                          fileUrl={previewUrl}
                          plugins={[defaultLayoutPluginInstance]}
                          renderError={() => <div>Error loading PDF</div>}
                        />
                      </Worker>
                    )}
                  </div>
                </div>
                {modalType === "cards" && (
                  <div className="flex justify-center mt-4">
                    <button
                      onClick={handleDownloadCompleteCards}
                      className="bg-primary hover:bg- text-white px-4 py-2 squared flex items-center"
                    >
                      <FaDownload className="mr-2" /> Download Complete Cards
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
      {showSingleCardModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white p-4 squared-lg w-full max-w-4xl h-full flex flex-col relative z-60">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-semibold">Card Preview</h2>
              <button
                onClick={resetStates}
                className="bg-primary text-white squared-full p-2"
              >
                <FaTimes />
              </button>
            </div>
            <div className="flex-grow h-full overflow-y-auto">
              {previewUrl && (
                <Worker workerUrl={pdfWorker}>
                  <Viewer
                    fileUrl={previewUrl}
                    plugins={[defaultLayoutPluginInstance]}
                    renderError={() => <div>Error loading PDF</div>}
                  />
                </Worker>
              )}
            </div>
          </div>
        </div>
      )}
      {isDeleteModalVisible && (
        <Modal
          title={
            <div className="text-lg font-medium text-gray-800">
              Confirm Deletion
            </div>
          }
          open={isDeleteModalVisible}
          onOk={handleDeleteModalOk}
          onCancel={() => {
            setIsDeleteModalVisible(false);
          }}
          okText="Delete"
          cancelText="Cancel"
          footer={[
            <button
              key="cancel"
              onClick={() => {
                setIsDeleteModalVisible(false);
              }}
              className="py-2 px-4 text-sm mr-2 font-medium text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 focus:ring-2 focus:ring-gray-400"
            >
              Cancel
            </button>,
            <button
              key="delete"
              onClick={handleDeleteModalOk}
              disabled={deleteLoading}
              className="py-2 px-4 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 focus:ring-2 focus:ring-red-400"
            >
              {deleteLoading ? "Deleting..." : "Proceed"}
            </button>,
          ]}
          styles={{
            padding: "16px",
          }}
          wrapClassName="custom-modal"
          centered
        >
          <p className="text-gray-600">
            Are you sure you want to delete the selected orders?
          </p>
        </Modal>
      )}
    </div>
  );
};

export default PrintQueue;

// const handleChangeStatus = useCallback(
//   async (newStatus) => {
//     setLoading(true);
//     console.log({ selectedCards });
//     // Ensure no duplicates in selectCustomers array
//     const uniqueCustomers = Array.from(new Set(selectCustomers));
//     try {
//       const response = await api.put(`/admin/change-status-admin/batch`, {
//         cardIds: selectedCards,
//         customerId: uniqueCustomers,
//         newStatus,
//       });

//       if (response.data.code === 200) {
//         setCards((prevCards) =>
//           prevCards.map((card) =>
//             selectedCards.includes(card._id)
//               ? {
//                   ...card,
//                   status: newStatus === "printed" ? "printed" : "mailed",
//                 }
//               : card
//           )
//         );
//         setSelectedCards([]);
//         setSelectedCustomers([]);
//         toast.success(`Selected cards marked as ${newStatus} successfully!`);
//       } else {
//         log.error(
//           `Failed to mark cards as ${newStatus}: ${response.data.message}`
//         );
//         toast.error(`Failed to mark selected cards as ${newStatus}`);
//       }
//     } catch (error) {
//       log.error(`Failed to mark cards as ${newStatus}:`, error);
//       toast.error(`Failed to mark selected cards as ${newStatus}`);
//     } finally {
//       setLoading(false);
//     }
//   },
//   [selectedCards]
// );
